export const APP_VERSION = '1.0.0';

const BASE_KFUSE_CONFIG = {
  applicationId: process.env.REACT_APP_KLOUDFUSE_APPLICATION_ID || '',
  clientToken: process.env.REACT_APP_KLOUDFUSE_CLIENT_TOKEN || '',
  service: process.env.REACT_APP_KLOUDFUSE_SERVICE_NAME || '',
  proxy: process.env.REACT_APP_KLOUDFUSE_PROXY || '',
  env: process.env.REACT_APP_KLOUDFUSE_ENV || '',
  version: APP_VERSION,
  sessionSampleRate: 100,
  defaultPrivacyLevel: 'allow' as const,
  enableLogCollection: true,
  enableSessionRecording: true,
};

export const getKfuseConfig = () => ({
  config: {
    ...BASE_KFUSE_CONFIG,
  },
});
